import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { createWebHooks, createRabbitMqSubscription } from './utils';

const FASTAPI_URL = process.env.REACT_APP_API_URL;

const QRCodeDisplay = () => {
    const { user_id } = useParams();
    const location = useLocation();
    const qrCode = location.state?.qrCode;
    const instanceId = location.state?.instanceId;

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [webhookCreated, setWebhookCreated] = useState(false);
    const [rabbitsubCreated, setRabbitsubCreated] = useState(true); //TODO: get rid of RabbitMQ Sub creation;
    //RabbitMQ Sub taken care of globally

    useEffect(() => {
        const setupIntegrations = async () => {
            if (!instanceId) {
                setError('Something went wrong. Press back and try again.');
                setLoading(false);
                return;
            }

            try {
                // Try to find webhook
                const webhookResponse = await axios.get(`${FASTAPI_URL}/api/webhook/find/${encodeURIComponent(instanceId)}`);

                if (webhookResponse.data === null) {
                    console.log('No webhook found. Creating...');
                    await createWebHooks(instanceId);
                } else {
                    console.log('Webhook already exists:', webhookResponse.data);
                }

                setWebhookCreated(true);
            } catch (err) {
                // Treat 404 as "not found" and create the webhook
                const status = err?.response?.status;
                if (status === 404) {
                    try {
                        console.log('Webhook not found (404). Creating...');
                        await createWebHooks(instanceId);
                        setWebhookCreated(true);
                    } catch (createErr) {
                        console.error('Error creating webhook after 404:', createErr);
                        setError('Failed to create webhook.');
                        setLoading(false);
                        return;
                    }
                } else {
                    console.error('Error fetching webhook:', err);
                    setError('Failed to check/create webhook.');
                    setLoading(false);
                    return;
                }
            }

            /*try {
                // Check and create RabbitMQ subscription
                const rabbitResponse = await axios.get(`${NODE_API_URL}/rabbitmq/find/${instanceId}`, {
                    headers: { apikey: 'BQYHJGJHJ' }
                });

                if (rabbitResponse.data === null) {
                    console.log('No RabbitMQ subscription found. Creating...');
                    await createRabbitMqSubscription(instanceId);
                } else {
                    console.log('RabbitMQ subscription already exists:', rabbitResponse.data);
                }

                setRabbitsubCreated(true);
            } catch (err) {
                console.error('Error fetching RabbitMQ subscription:', err);
                setError('Failed to check/create RabbitMQ subscription.');
                setLoading(false);
                return;
            }*/

            setLoading(false);
        };

        setupIntegrations();
    }, [instanceId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    if (!qrCode) {
        return <div style={{ color: 'red' }}>No QR code data was provided.</div>;
    }

    if (webhookCreated && rabbitsubCreated) {
        return (
            <div>
                <img src={qrCode} alt={`WhatsApp QR Code for User ID ${user_id}`} />
            </div>
        );
    }

    return null;
};

export default QRCodeDisplay;
